import BaseEffectAction from './BaseEffectAction.js';
import {initializeEffect} from 'components/effects/constants.js';

class ToggleEffectAction extends BaseEffectAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    execute({effect, track, group, send}) {
        let element = track || group || send;
        effect.toggleEnabled();
        if (!effect.isMidiEffect() && element.effectsChain) {
            element.effectsChain.updateEffects();
        } 
    }
}

export default ToggleEffectAction;
